import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedCollectionFilter,
  deleteSelectedCollectionFilter,
} from '../../actions/Collections';

import { slugify } from '../../helpers';
import { getFileAccessIcon } from '../../helpers/Files';

import FiltersResetButton from './FiltersResetButton';

const getVisibility = (key, intl) => {
  if (`${key}` === '1') {
    return intl.formatMessage({ defaultMessage: 'Open' });
  }
  return intl.formatMessage({ defaultMessage: 'Restricted' });
};

class FiltersCollectionVisibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };

    this.toggle = this.toggle.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  toggle() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  handleChangeFilter(e) {
    const {
      checked,
      value,
    } = e.target;
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;
    let { visibility: newSelected } = filters;
    if (checked) {
      newSelected.push(value);
      addFilter({
        type: 'visibility',
        key: `${value}`,
        label: getVisibility(value, intl),
        title: intl.formatMessage({ defaultMessage: 'Visibility' }),
      });
    } else {
      newSelected = newSelected.filter(s => (s !== `${value}`));
      removeFilter('visibility', value);
    }
    handleChangeFilters({ visibility: newSelected });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ visibility: [] });
    clearSelectedFilters('visibility');
  }

  render() {
    const { collapse } = this.state;
    const {
      intl,
      availableFilters,
      filters,
    } = this.props;
    const selected = filters.visibility;

    return (
      <div className="files-filter file-visibility-filter">
        <div className="filter-header">
          <Button onClick={this.toggle} className="filter-title">
            <i className={`fal fa-angle-${collapse ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'Collection visibility' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={collapse}
          className="filter-body"
        >
          <div className="filter-form file-visibility-filter-form">
            {availableFilters.map(ft => (
              <FormGroup key={`filevisibility-${slugify(ft.key)}`}>
                <Label for={`checkFileVisibility-${slugify(ft.key)}`} check>
                  <Input
                    type="checkbox"
                    name="fileVisibility"
                    id={`checkFileVisibility-${slugify(ft.key)}`}
                    className="input-check check-s"
                    value={`${ft.key}`}
                    checked={selected.find(s => (s === `${ft.key}`)) || false}
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    <i className={`fas ${getFileAccessIcon({ public: ft.key })}`} />
                    {' '}
                    {getVisibility(ft.key, intl)}
                  </span>
                </Label>
              </FormGroup>
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.Collections.filters,
});

const mapDispatchToProps = dispatch => ({
  addFilter: (filter) => {
    dispatch(addSelectedCollectionFilter(filter));
  },
  removeFilter: (filterType, filterKey) => {
    dispatch(deleteSelectedCollectionFilter(filterType, filterKey));
  },
  clearSelectedFilters: (filterType) => {
    dispatch(deleteSelectedCollectionFilter(filterType, null));
  },
});

FiltersCollectionVisibility.propTypes = {
  intl: PropTypes.object.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  availableFilters: PropTypes.array.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FiltersCollectionVisibility),
);
